import { render, staticRenderFns } from "./CargoCarrierTypes.vue?vue&type=template&id=82b5963e&scoped=true&"
import script from "./CargoCarrierTypes.vue?vue&type=script&lang=js&"
export * from "./CargoCarrierTypes.vue?vue&type=script&lang=js&"
import style0 from "./CargoCarrierTypes.vue?vue&type=style&index=0&id=82b5963e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b5963e",
  null
  
)

/* custom blocks */
import block0 from "./CargoCarrierTypes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports